export const EXCEPTION_BILLER_PAYEE_CODE = ['0023', '000500', '002500'];
